<template>
    <span
        :class="disabled ? 'module-disabled-struct' : ''"
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('gallery')})
                : ''
        ">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <License
                :license-link="settings.licenseLink"
                v-if="isDateStringPast(settings.clickAndBuyLicensedUntil)"
                :licensed-until="settings.clickAndBuyLicensedUntil"
                :description="$t(moduleName)"
                class="uk-margin-medium-bottom" />
            <div
                v-else-if="!settings.clickAndBuyLicensedUntil"
                class="uk-margin-medium-bottom">
                <InfoBox mode="primary" icon="info">
                    {{
                        $t('x.module.disabled.message', {
                            x: $t(moduleName),
                        })
                    }}
                </InfoBox>
            </div>

            <ul uk-tab="animation: uk-animation-fade">
                <li
                    v-for="tab in [
                        'lunacart',
                        'variants',
                        'design',
                        'license',
                    ]"
                    :key="tab">
                    <a href="#">{{ $t(tab) }}</a>
                </li>
            </ul>
            <ul class="uk-switcher uk-margin">
                <li>
                    <InfoBox v-if="limitReached" icon="warning" mode="danger">
                        <Translate
                            translation-key="clickandbuy.limit.reached"
                            :parameter="{x: settings.clickAndBuyInfos.limit}" />
                    </InfoBox>
                    <div v-if="limitReached" class="uk-margin-medium-top" />

                    <span
                        :uk-tooltip="
                            'title:' +
                            (limitReached
                                ? $t('clickandbuy.limit.reached', {
                                      x: settings.clickAndBuyInfos.limit,
                                  })
                                : '')
                        ">
                        <Button
                            :action="actionNew"
                            :is-disabled="limitReached"
                            has-action
                            mode="primary">
                            {{ $t('x.add', {x: $t('campaign')}) }}
                        </Button>
                    </span>

                    <div class="uk-margin-medium-top" />
                    <div v-if="!computedList || computedList.length === 0">
                        {{ $t('none.x', {x: $t('clickandbuys')}) }}
                    </div>
                    <div v-else class="uk-overflow-auto lunacart-struct">
                        <table
                            class="uk-table uk-table-middle uk-table-divider uk-table-hover">
                            <thead>
                                <tr>
                                    <th class="uk-table-shrink">
                                        {{ $t('media') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('title') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('variants') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('link') }}
                                    </th>
                                    <th class="uk-table-shrink">
                                        {{ $t('qr.code') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('price') }}
                                    </th>
                                    <th class="uk-table-shrink">
                                        {{ $t('shippingFee') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('file') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('description') }}
                                    </th>

                                    <th class="uk-table-shrink uk-text-nowrap">
                                        {{ $t('clickandbuy.email.text') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('active') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('listed') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('multipleOrder') }}
                                    </th>
                                    <th class="uk-table-shrink">
                                        {{ $t('shippingMultiple') }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    :id="item.id"
                                    v-for="(item, key) in computedList"
                                    :key="'clickandbuy-' + key"
                                    :class="
                                        'cursor-pointer uk-text-nowrap' +
                                        (item.id === hoveredId
                                            ? ' uk-table-hovered'
                                            : '')
                                    ">
                                    <td v-on:click="actionSelect(item)">
                                        <Modal
                                            is-extended
                                            :id="modalIdUpdate + item.id"
                                            :title="
                                                $t('x.change', {
                                                    x: $t('campaign'),
                                                })
                                            ">
                                            <ClickAndBuyForm
                                                :id="item.id"
                                                :settings="settings"
                                                @declared="actionGet"
                                                :modal-id="
                                                    modalIdUpdate + item.id
                                                "
                                                :click-and-buy="item"
                                                :variants="variants"
                                                :disabled="disabled" />
                                        </Modal>

                                        <div
                                            class="uk-card uk-card-default uk-card-hover cursor-pointer">
                                            <div
                                                class="uk-inline uk-transition-toggle uk-width-1-1">
                                                <div v-if="item.mediaFileId">
                                                    <div
                                                        :data-src="
                                                            apiUrl +
                                                            '/manage-clickandbuys/' +
                                                            item.id +
                                                            '/media/' +
                                                            item.mediaFileId +
                                                            '?token=' +
                                                            getToken
                                                        "
                                                        class="thumbnail-height uk-background-cover"
                                                        uk-img />
                                                </div>
                                                <div v-else>
                                                    <div
                                                        class="thumbnail-height uk-flex uk-flex-center uk-flex-middle uk-background-cover">
                                                        {{
                                                            $t('no.x', {
                                                                x: $t('media'),
                                                            })
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-margin-small-right"
                                            icon="hashtag" />
                                        {{ item.title }}
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-margin-small-right"
                                            icon="settings" />
                                        {{
                                            item.variantIds
                                                ? item.variantIds.length
                                                : 0
                                        }}
                                    </td>

                                    <td class="uk-text-center">
                                        <span
                                            class="cursor-pointer"
                                            v-on:click="
                                                actionLinkToClipboard(item)
                                            "
                                            :uk-tooltip="
                                                'title:' +
                                                $t('copy.to.clipboard')
                                            ">
                                            <Icon icon="copy-clipboard" />
                                        </span>
                                        <span
                                            class="uk-margin-small-left cursor-pointer"
                                            v-on:click="actionLinkOpen(item)"
                                            :uk-tooltip="'title:' + $t('open')">
                                            <Icon icon="link" />
                                        </span>
                                    </td>

                                    <td>
                                        <div
                                            :uk-tooltip="
                                                'title:' + $t('download')
                                            "
                                            class="qr-code"
                                            v-on:click="
                                                actionDownloadQRCode(item)
                                            "
                                            :id="
                                                'clickandbuyqrcode' + item.id
                                            " />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-margin-small-right"
                                            icon="tag" />
                                        {{
                                            item.price && item.price > 0
                                                ? getNumberWithCurrency(
                                                      item.price
                                                  )
                                                : $t('free')
                                        }}

                                        <Icon
                                            v-if="item.isPriceVariable"
                                            class="uk-margin-small-left"
                                            :uk-tooltip="
                                                'title:' + $t('variable.price')
                                            "
                                            icon="settings" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-margin-small-right"
                                            icon="cart" />
                                        {{
                                            item.shippingFee &&
                                            item.shippingFee > 0
                                                ? getNumberWithCurrency(
                                                      item.shippingFee
                                                  )
                                                : $t('free')
                                        }}
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.articleFileId"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('with.x', {
                                                    x: $t('file'),
                                                })
                                            "
                                            icon="bag" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('without.x', {
                                                    x: $t('file'),
                                                })
                                            "
                                            icon="close" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.text"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('with.x', {
                                                    x: $t('description'),
                                                })
                                            "
                                            icon="commenting" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('without.x', {
                                                    x: $t('description'),
                                                })
                                            "
                                            icon="close" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.emailText"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('with.x', {
                                                    x: $t(
                                                        'clickandbuy.email.text'
                                                    ),
                                                })
                                            "
                                            icon="mail" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('without.x', {
                                                    x: $t(
                                                        'clickandbuy.email.text'
                                                    ),
                                                })
                                            "
                                            icon="close" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.disabled"
                                            :uk-tooltip="
                                                'title:' + $t('disabled')
                                            "
                                            icon="ban" />
                                        <Icon
                                            class="uk-text-success"
                                            v-else
                                            :uk-tooltip="
                                                'title:' + $t('active')
                                            "
                                            icon="bolt" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-text-success"
                                            v-if="!item.hidden"
                                            :uk-tooltip="
                                                'title:' + $t('listed')
                                            "
                                            icon="eye" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' + $t('not.listed')
                                            "
                                            icon="eye-closed" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class=""
                                            v-if="item.multipleOrderable"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('multipleOrderable')
                                            "
                                            icon="copy" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('not.multipleOrderable')
                                            "
                                            icon="file" />
                                    </td>
                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="
                                                !item.shippingFee ||
                                                item.shippingFee === 0
                                            "
                                            :uk-tooltip="
                                                'title:' + $t('no.shipping')
                                            "
                                            icon="close" />

                                        <Icon
                                            v-else-if="
                                                !item.shippingCostsOnce &&
                                                item.multipleOrderable
                                            "
                                            :uk-tooltip="
                                                'title:' +
                                                $t('not.shippingCostsOnce')
                                            "
                                            icon="chevron-double-right" />
                                        <Icon
                                            v-else
                                            class=""
                                            :uk-tooltip="
                                                'title:' +
                                                $t('shippingCostsOnce')
                                            "
                                            icon="chevron-right" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="uk-margin-medium-top" />

                    <div v-if="computedList && computedList.length > 0">
                        <span
                            :uk-tooltip="
                                'title:' +
                                (limitReached
                                    ? $t('clickandbuy.limit.reached', {
                                          x: settings.clickAndBuyInfos.limit,
                                      })
                                    : '')
                            ">
                            <Button
                                :action="actionNew"
                                :is-disabled="limitReached"
                                has-action
                                mode="primary">
                                {{ $t('x.add', {x: $t('campaign')}) }}
                            </Button>
                        </span>
                    </div>
                </li>
                <li>
                    <div>
                        <ClickAndBuyVariantsForm
                            :disabled="disabled"
                            @declared="variantsDeclared"
                            :variants="settings.clickAndBuySettings.variants" />
                    </div>
                </li>
                <li>
                    <div
                        class="uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match"
                        uk-grid>
                        <div>
                            <ClickAndBuyNameForm
                                :disabled="disabled"
                                :text="settings.clickAndBuySettings.name" />
                        </div>
                        <div>
                            <ClickAndBuyTitleForm
                                :disabled="disabled"
                                :text="settings.clickAndBuySettings.title" />
                        </div>
                        <div>
                            <ClickAndBuyCompanyForm
                                :disabled="disabled"
                                :text="settings.clickAndBuySettings.company" />
                        </div>
                        <div>
                            <ClickAndBuyLogoForm
                                :disabled="disabled"
                                :click-and-buy-only="computedClickAndBuyOnly"
                                :data="getInfos.clickAndBuy.logo"
                                @updated="receiveInfos"
                                :allowed-extensions="fileExtensionsBackground"
                                :allowed-size="allowedFaviconSize" />
                        </div>
                        <div>
                            <ClickAndBuyColorForm
                                :disabled="disabled"
                                :mode="
                                    settings.clickAndBuySettings.themeColorMode
                                "
                                :text="
                                    settings.clickAndBuySettings.themeBackgroundColor
                                " />
                        </div>
                        <div>
                            <ClickAndBuyLinksForm
                                :disabled="disabled"
                                :text="settings.clickAndBuySettings.links" />
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match"
                        uk-grid>
                        <div
                            v-if="!settings.clickAndBuyLicensedUntil"
                            class="uk-width-1-1">
                            <InfoBox mode="primary" icon="info">
                                {{
                                    $t('x.module.disabled.message', {
                                        x: $t(moduleName),
                                    })
                                }}
                            </InfoBox>
                        </div>
                        <div v-else class="uk-width-1-1">
                            <License
                                :license-link="settings.licenseLink"
                                :licensed-until="
                                    settings.clickAndBuyLicensedUntil
                                "
                                :description="$t(moduleName)" />
                        </div>
                    </div>
                </li>
            </ul>

            <Modal
                is-extended
                :id="modalIdCreate"
                :title="$t('x.add', {x: $t('campaign')})">
                <ClickAndBuyForm
                    :variants="variants"
                    v-if="!loading"
                    id="new"
                    :settings="settings"
                    @declared="actionGet"
                    :modal-id="modalIdCreate"
                    :click-and-buy="{
                        id: null,

                        title: '',
                        text: '',

                        emailText: '',
                        mediaFileId: null,

                        articleFileId: null,
                        price: 0,

                        disabled: false,
                    }"
                    :disabled="disabled" />
            </Modal>
        </span>
    </span>
</template>

<script>
import License from '@/components/License.vue';
import InfoBox from '@/components/generic/InfoBox.vue';
import ClickAndBuyTitleForm from '@/views/clickandbuy/ClickAndBuyTitleForm.vue';
import ClickAndBuyColorForm from '@/views/clickandbuy/ClickAndBuyColorForm.vue';
import Translate from '@/components/Translate.vue';
import Button from '@/components/generic/Button.vue';
import UIkit from 'uikit';
import Modal from '@/components/generic/Modal.vue';
import ClickAndBuyForm from '@/views/clickandbuy/ClickAndBuyForm.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import QRCode from 'easyqrcodejs';
import Vue from 'vue';
import ClickAndBuyLogoForm from '@/views/clickandbuy/ClickAndBuyLogoForm.vue';
import ClickAndBuyNameForm from '@/views/clickandbuy/ClickAndBuyNameForm.vue';
import ClickAndBuyLinksForm from '@/views/clickandbuy/ClickAndBuyLinksForm.vue';
import ClickAndBuyCompanyForm from '@/views/clickandbuy/ClickAndBuyCompanyForm.vue';
import ClickAndBuyVariantsForm from './ClickAndBuyVariantsForm.vue';

export default {
    name: 'ClickAndBuyAdmin',
    components: {
        ClickAndBuyVariantsForm,
        ClickAndBuyCompanyForm,
        ClickAndBuyLinksForm,
        ClickAndBuyNameForm,
        ClickAndBuyLogoForm,
        Icon,
        ClickAndBuyForm,
        Modal,
        Button,
        Translate,
        ClickAndBuyColorForm,
        ClickAndBuyTitleForm,
        InfoBox,
        License,
    },
    data() {
        return {
            moduleName: 'clickandbuy',

            modalIdCreate: 'modal-clickandbuy-create',
            modalIdUpdate: 'modal-clickandbuy-update-',

            selected: {},

            list: [],

            hoveredId: 0,

            qrCodes: [],
            loading: false,

            variants: [],
        };
    },
    props: {
        settings: Object,
        disabled: Boolean,
    },
    created() {
        this.actionGetVariants();
        this.actionGet();
    },
    mounted() {
        this.generateQrCodes();
    },
    methods: {
        variantsDeclared() {
            this.actionGetVariants();
            this.actionGet();
        },
        actionGetVariants() {
            this.loading = true;
            let http = axios.create();
            http.get(this.apiUrl + '/manage-variants')
                .then((response) => {
                    this.variants = response.data;
                })
                .catch((e) => {
                    this.checkGenericError(e);
                });
        },
        actionGetLink(clickandbuy) {
            if (this.settings.clickAndBuyInfos.domain) {
                return (
                    'https://' +
                    this.settings.clickAndBuyInfos.domain +
                    '/' +
                    this.$i18n.locale +
                    '/' +
                    clickandbuy.id
                );
            }

            return (
                window.location.origin +
                '/' +
                this.$i18n.locale +
                '/lunacart/' +
                clickandbuy.id
            );
        },
        generateQrCodes() {
            let self = this;
            setInterval(function () {
                for (let i = 0, j = self.computedList.length; i < j; i++) {
                    let clickandbuy = self.computedList[i];

                    if (self.computedQrCodes[clickandbuy.id]) {
                        return;
                    }

                    let refElement = document.getElementById(
                        'clickandbuyqrcode' + clickandbuy.id
                    );
                    if (!refElement) {
                        return;
                    }

                    let optionsDownload = {
                        text: self.actionGetLink(clickandbuy),
                        drawer: 'svg',
                    };

                    Vue.set(
                        self.qrCodes,
                        clickandbuy.id,
                        new QRCode(refElement, optionsDownload)
                    );
                }
            }, 50);
        },
        actionDownloadQRCode(clickandbuy) {
            this.computedQrCodes[clickandbuy.id].download(
                'lunacart ' + clickandbuy.title
            );
        },
        actionLinkOpen(clickandbuy) {
            let link = this.actionGetLink(clickandbuy);

            event.stopPropagation();
            event.preventDefault();
            window.open(link, '_blank').focus();
        },
        actionLinkToClipboard(clickandbuy) {
            let link = this.actionGetLink(clickandbuy);

            this.copyToClipboard(link);

            UIkit.notification({
                message: this.$t('copied.to.clipboard', {
                    description: this.$t('link'),
                }),
                status: 'info',
                pos: 'top-center',
                timeout: this.notificationTimeout,
            });
        },
        actionNew() {
            this.selected = {};
            UIkit.modal('#' + this.modalIdCreate).show();
        },
        actionSelect(select) {
            this.selected = select;
            UIkit.modal('#' + this.modalIdUpdate + select.id).show();
        },
        actionGet(id) {
            if (id) {
                this.hoveredId = id;
            }

            this.loading = true;
            let http = axios.create();
            http.get(this.apiUrl + '/manage-clickandbuys')
                .then((response) => {
                    if (response.data) {
                        this.list = response.data;
                    } else {
                        this.list = [];
                    }

                    this.qrCodes = [];

                    this.loading = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                });
        },
    },
    computed: {
        allowedFaviconSize() {
            if (this.settings.maxFileSizeForBackgroundPicturesInMB) {
                return this.settings.maxFileSizeForBackgroundPicturesInMB;
            }

            return 0;
        },
        fileExtensionsBackground() {
            if (this.settings.allowedFileExtensions) {
                return this.settings.allowedFileExtensions;
            }

            return [];
        },
        computedClickAndBuyOnly() {
            return (
                this.settings &&
                this.settings.clickAndBuyInfos &&
                this.settings.clickAndBuyInfos.only === true
            );
        },
        computedQrCodes() {
            return this.qrCodes;
        },
        computedList() {
            return this.list;
        },
        limitReached() {
            return (
                this.list &&
                this.settings.clickAndBuyInfos &&
                this.list.length >= this.settings.clickAndBuyInfos.limit
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.thumbnail-height {
    height: 45px;
    border-radius: 5px;
}

.qr-code {
    height: 80px;
    width: 80px;
}

.lunacart-struct {
    font-size: 14px;
}
</style>
